export enum TableType {
  Datasets = "datasets",
  Files = "files",
  Topics = "topics",
  MessagePaths = "message_paths",
  Events = "events",
  Sessions = "sessions",
}

export interface TablePreferences {
  columns: string[];
  rowsPerPage: number;
}

export const DEFAULT_ROWS_PER_PAGE = 25;

export const DEFAULT_TABLE_COLUMNS: Record<TableType, string[]> = {
  [TableType.Datasets]: ["dataset_id", "name", "created", "source", "tags"],
  [TableType.Files]: ["name", "created", "source", "association_id", "tags"],
  [TableType.Topics]: ["topic_id", "topic_name", "created", "message_count"],
  [TableType.MessagePaths]: [
    "message_path_id",
    "message_path",
    "topic_id",
    "data_type",
    "created",
  ],
  [TableType.Events]: ["event_id", "name", "start_time", "created", "tags"],
  [TableType.Sessions]: [
    "session_id",
    "name",
    "min_timestamp_ns",
    "max_timestamp_ns",
    "duration",
    "created_by",
  ],
};
